import { Table } from '@tanstack/react-table'

import { MultiSelectCombobox } from '@/components/form-components/MultiSelectCombobox'

import { DataAssetSummaryRow, WorkspaceDataAssetsFilterOptions } from './workspaceDataAssetsTableUtils'

type WorkspaceDataAssetsFiltersProps = {
  table: Table<DataAssetSummaryRow>
} & WorkspaceDataAssetsFilterOptions

export function WorkspaceDataAssetsFilters({
  table,
  entityTypeOptions,
  dataAssetOptions,
  entityNameOptions,
}: WorkspaceDataAssetsFiltersProps) {
  const selectedEntityTypes = ((table.getColumn('entityTypeName')?.getFilterValue() as string[] | undefined) ?? []).filter(
    Boolean
  )
  const selectedDataAssets = ((table.getColumn('dataAssetName')?.getFilterValue() as string[] | undefined) ?? []).filter(
    Boolean
  )
  const selectedEntityNames = ((table.getColumn('entityName')?.getFilterValue() as string[] | undefined) ?? []).filter(
    Boolean
  )

  return (
    <>
      <div className="w-56">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={entityTypeOptions}
          selectedValues={selectedEntityTypes}
          onSelectionChange={(values) =>
            table.getColumn('entityTypeName')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By Entity Types"
          searchPlaceholder="Search entity types..."
          emptyMessage="No entity types found."
        />
      </div>
      <div className="w-56">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={dataAssetOptions}
          selectedValues={selectedDataAssets}
          onSelectionChange={(values) =>
            table.getColumn('dataAssetName')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By Data Assets"
          searchPlaceholder="Search data assets..."
          emptyMessage="No data assets found."
        />
      </div>
      <div className="w-56">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={entityNameOptions}
          selectedValues={selectedEntityNames}
          onSelectionChange={(values) =>
            table.getColumn('entityName')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By Entity Names"
          searchPlaceholder="Search entity names..."
          emptyMessage="No entity names found."
        />
      </div>
    </>
  )
}
